<template>
  
  <v-app>

      <home></home>
   
  </v-app>
</template>

<script>
//import Clientes from './components/Registro/Clientes';
import home from './components/Home.vue';

export default {
  name: 'App',

  components: {
  //  Clientes,
    home
  },

  data: () => ({
    //
  }),

  
};
</script>
